import{useContext as t}from"react";import n from"../components/ConnectContext.js";const e=()=>t(n).wallet?.wallet?.contents;var r=e;export{r as default};
